import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InterventionTeamEditorComponent} from './intervention-team-editor.component';
import {ChappsCommonAngularLibraryModule} from "@npm.chapps.com/chapps.common.angular.library";
import {CheckboxModule, MdProgressBarModule, MdProgressSpinnerModule, TooltipModule} from "ng-uikit-pro-standard";
import {FormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {InterventionTeamContactResource} from "../../contacts/intervention-team-contact-resource.service";
import {EditNameDialogModule} from "../edit-name-dialog/edit-name-dialog.module";
import {MatTooltipModule} from '@angular/material/tooltip';


@NgModule({
  declarations: [
    InterventionTeamEditorComponent,
  ],
  exports: [
    InterventionTeamEditorComponent
  ],
  providers: [
    InterventionTeamContactResource,
  ],
  imports: [
    CommonModule,
    ChappsCommonAngularLibraryModule,
    CheckboxModule,
    FormsModule,
    MatTooltipModule,
    TooltipModule,
    TranslateModule,
    EditNameDialogModule,
    MdProgressSpinnerModule,
    MdProgressBarModule,
  ]
})
export class InterventionTeamEditorModule {
}
